import { Directive, ElementRef, HostBinding, Input, OnChanges } from '@angular/core';
import { NetworkService } from '@damofire/data-angular-commons';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '../auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Directive({
  selector: '[appDisabledOffline]',
  standalone: true,
})
export class DisabledOfflineDirective implements OnChanges {
  private readonly sub: Subscription;

  @Input()
  appDisabledOffline: boolean | string;

  @Input()
  hasOfflineNavigationAccess = false;

  @HostBinding('class.mat-button-disabled')
  @HostBinding('class.mat-radio-disabled')
  @HostBinding('class.mat-disabled')
  @HostBinding('attr.disabled')
  isDisabled: true | null = null;

  constructor(
    private readonly el: ElementRef,
    private readonly networkService: NetworkService,
  ) {
    this.sub = this.networkService.status.subscribe(() => this.disableIfNeeded());
  }

  ngOnChanges() {
    this.disableIfNeeded();
  }

  private disableIfNeeded() {
    if (this.hasOfflineNavigationAccess) {
      this.isDisabled = null;
      this.el.nativeElement.style['pointer-events'] = 'auto';
      return;
    }
    const disable = !this.networkService.connected || this.appDisabledOffline;
    this.isDisabled = !disable ? null : true;
    this.el.nativeElement.style['pointer-events'] = !disable ? 'auto' : 'none';
  }
}
